import { connect } from 'react-redux';
import utils from 'utils';
import FlyoutTabs from './FlyoutTabs';

const mapStateToProps = state => ({
  breakpoint: state.getIn(['app', 'breakpoint']),
});

export default connect(mapStateToProps)(utils.toJS(FlyoutTabs));
